import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { RootState } from '../../../state/state';
import { EligibilityEngineService } from '../eligibility-engine.service';
import {
  loadEligibilityEngineRules,
  loadEligibilityEngineRulesSuccess,
  loadEligibilityEngineRulesFailure,
} from './eligibility-engine-service.actions';
import { catchError, map, mergeMap, of, withLatestFrom } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ReservationServiceSelectors } from '../../reservation-service/state/reservation-service.selectors';
import { SplitioService } from '../../splitio-service/splitio.service';
import { Splits } from '../../splitio-service/splits';

@Injectable()
export class EligibilityEngineServiceEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject<Store<RootState>>(Store);
  private readonly eligibilityEngineService = inject(EligibilityEngineService);
  private readonly splitioService = inject(SplitioService);

  loadEligibilityEngineRules$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadEligibilityEngineRules),
      withLatestFrom(this.store.select(ReservationServiceSelectors.getRoutedConfirmationCode)),
      mergeMap(([action, confirmationCode]) => {
        if (!confirmationCode) {
          return of(loadEligibilityEngineRulesFailure({ message: 'No confirmation code available' }));
        }
        const allowNonRefundable = this.splitioService.splitClient.getTreatment(Splits.Voluntary_Change_Allow_Non_Refundable);
        return this.eligibilityEngineService.getRebookEligibility(confirmationCode, allowNonRefundable).pipe(
          map((response) => loadEligibilityEngineRulesSuccess([response])),
          catchError((err: HttpErrorResponse) => {
            return of(loadEligibilityEngineRulesFailure(err));
          })
        );
      })
    )
  );
}
